export const GROUP_MANAGE = 'groupManage' 
export const FORM_ITEM = {
    name:'',
    group_key:'',
    desc:''
}